import e from"./ChangePassword/ChangePassword.mjs";import r from"./DeleteUser/DeleteUser.mjs";var s={ChangePassword:e,DeleteUser:r};export{s as default};
